import { CarvanaHeaderProvider } from '@carvana/header';
import dynamic from 'next/dynamic';
import React from 'react';
import EvData from '~/components/ev-tax-credit/EvData';
import AnalyticsProvider from '~/context/common/AnalyticsProvider';
import {
  defaultContext,
  DeviceContextProvider
} from '~/context/common/DeviceContext';
import { UserContextProvider } from '~/context/common/UserContext';
import { DeviceDetectionContextProvider } from '~/context/giveaway/DeviceDetectionContext';

const CoreAuth = dynamic(
  () => import(/* webpackChunkName: "CoreAuth" */ '@/common/CoreAuth'),
  { ssr: false }
);

type OwnProps = React.PropsWithChildren<{
  eventableProject: string;
  eventableTrack: string;
}>;

const EvProviders = ({
  children,
  eventableProject,
  eventableTrack
}: OwnProps) => (
  <CarvanaHeaderProvider>
    <AnalyticsProvider projectName={eventableProject} track={eventableTrack}>
      <DeviceContextProvider {...defaultContext}>
        <DeviceDetectionContextProvider>
          <UserContextProvider location={{}}>
            <CoreAuth />
            <EvData />
            {children}
          </UserContextProvider>
        </DeviceDetectionContextProvider>
      </DeviceContextProvider>
    </AnalyticsProvider>
  </CarvanaHeaderProvider>
);

export default EvProviders;
